var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgShare = function SvgShare(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M4.95 17.794a4.75 4.75 0 0 1-3.357-8.125l2.638-2.632a4.738 4.738 0 0 1 6.713 0c.233.226.443.475.624.744a.67.67 0 1 1-1.118.738 3.412 3.412 0 0 0-5.25-.531l-2.638 2.637a3.403 3.403 0 1 0 4.813 4.813l1.312-1.313a.672.672 0 1 1 .95.95l-1.312 1.313a4.726 4.726 0 0 1-3.375 1.406Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#1D1D1B",
    d: "M10.412 12.331a4.738 4.738 0 0 1-3.356-1.387 4.64 4.64 0 0 1-.625-.744.67.67 0 1 1 1.119-.737 3.412 3.412 0 0 0 5.25.531l2.637-2.638a3.403 3.403 0 1 0-4.812-4.812L9.312 3.856a.672.672 0 0 1-.95-.95l1.313-1.312a4.75 4.75 0 1 1 6.712 6.719l-2.631 2.63a4.75 4.75 0 0 1-3.344 1.388Z"
  })));
};
export default SvgShare;